import warning from 'warning';
import { isRaygunAvailable } from './utils.js';
import { groupByErrorMessage as groupByErrorMessageCallback } from './reporting.js';
import { filterCreditCards } from './filtering.js';
export default function (apiKey, appConfig = {}, options = {}, breadcrumbsApi = []) {
    const raygun = isRaygunAvailable();

    if (raygun) {
        const { enableCrashReporting, enablePulse, saveIfOffline, captureMissingRequests, groupByErrorMessage, withTags, setVersion } = appConfig;
        if (!apiKey) {
            warning('apiKey is not defined');
        }
        raygun('apiKey', apiKey);
        raygun('enableCrashReporting', !!enableCrashReporting);
        raygun('enablePulse', !!enablePulse);
        raygun('saveIfOffline', !!saveIfOffline);
        raygun('captureMissingRequests', !!captureMissingRequests);
        raygun('onBeforeSend', filterCreditCards);

        if (groupByErrorMessage) {
            raygun('groupingKey', groupByErrorMessageCallback);
        }

        if (withTags) {
            raygun('withTags', withTags);
        }

        if (setVersion) {
            raygun('setVersion', setVersion);
        }

        raygun('options', options);

        breadcrumbsApi.forEach((option) => {
            raygun(option.key, option.value);
        });
    } else {
        warning('Raygun is undefined, could not set up agent');
    }
}
